import React, { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { showModal } from '../actions/modal';

import { getDocLastUpdate } from '../utils/doc';

import UserName from './user-name';
import Tooltip from './tooltip';
import DateTime from 'components/DateTime';
import DocIcon from 'components/DocIcon';

import Placeholder from './placeholders/card.placeholder';

import IconRemove from '../icons/icon-remove';

class DocCard extends PureComponent {
    handleClick = () => {
        showModal('DOCUMENT_MODAL', {
            docId: this.props.id,
            updatedAt: this.props.updated_at
        });
    }

    handleRemoveClick = () => {
        this.props.onRemove(this.props.id);
    }

    getLastEditedMessage(date, userId) {
        const { t } = this.props;

        if (new Date() - date > 60000) {
            return <Trans
                i18nKey="date:Updated on by"
                values={{ date: new Date(date).toISOString() }}
                components={{
                    DateTime: <DateTime format="fullDateTime" />,
                    UserName: <UserName id={userId} />,
                    Divider: <React.Fragment />
                }}
            />
        } else {
            return <Trans
                i18nKey="date:Updated now by"
                values={{ date: new Date(date).toISOString() }}
                components={{
                    UserName: <UserName id={userId} />
                }}
            />
        }
    }

    render() {
        const { t } = this.props;

        if (this.props.loading) {
            return <div className="discussion-card"><Placeholder /></div>;
        }

        const lastEdit = getDocLastUpdate(this.props.members, this.props.author, this.props.created_at);

        return (
            <div className="card discussion-card">
                <div className="card-inner" onClick={this.handleClick}>
                    <div className="card-head">
                        <div className="card-icon">
                            <DocIcon type={this.props.type} subtype={this.props.subtype} size="40px" />
                        </div>
                    </div>

                    <div className="card-main">
                        <div className="card-body">
                            <h4>{ this.props.name }</h4>
                        </div>

                        <div className="card-foot">
                            <div className="card-meta">
                                <div className="item">
                                    { t('Docs') }
                                </div>
                            </div>

                            <span className="card-foot-additional">
                                <i className="icon ion ion-android-refresh" /> {this.getLastEditedMessage(lastEdit.date, lastEdit.userId)}
                            </span>
                        </div>
                    </div>
                </div>


                {
                    this.props.onRemove ? (
                        <div className="card-actions">
                            <Tooltip tooltip={this.props.removeTooltip}>
                                <button className="btn btn-square btn-icon btn-xxsmall" onClick={this.handleRemoveClick}>
                                    <IconRemove size="16px" />
                                </button>
                            </Tooltip>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

export default withTranslation(['doc', 'date'])(DocCard);
